<template>
  <div class="ab-leads-data">
    <AbBlock title="丰富的数据产品" subTitle="全面赋能数字化贸易">
      <div class="leads-item-industry">
        <a-row>
          <a-col :xs="6" :xl="6">
            <div class="leads-item-list">
              <div class="fontsize26">数据市场</div>
              <div class="fontsize16">
                基于云计算，通过贸易数据挖掘与分析，为企业提供全场景数据化服务。
              </div>
              <p class="fontsize16"><i></i> 洞察市场，需求预测</p>
              <p class="fontsize16"><i></i> 商情勘测，竞品分析</p>
              <p class="fontsize16"><i></i> 数据挖掘，策略投放</p>
              <p class="fontsize16"><i></i> 品牌溢价，资产沉淀</p>
            </div>
          </a-col>
          <a-col :xs="6" :xl="6">
            <router-link to="/product/customs">
              <div class="leads-item-hgsj">
                <img src="~@/assets/images/product/icon_双重数据筛选.png" />
                <div class="leads-hgsj-1">
                  <div class="fontsize22">
                    海关数据
                  </div>
                  <div class="fontsize18">实时进出口贸易数据</div>
                </div>
              </div>
            </router-link>
          </a-col>
          <a-col :xs="6" :xl="6">
            <router-link to="/product/intelligent-search">
              <div class="leads-item-hgsj">
                <img src="~@/assets/images/product/icon_全域数字营销.png" />
                <div class="leads-hgsj-1">
                  <div class="fontsize22">
                    客户智搜
                  </div>
                  <div class="fontsize18">海外企业信息全景透视</div>
                </div>
              </div>
            </router-link>
          </a-col>
          <a-col :xs="6" :xl="6">
            <router-link to="/product/search-customer">
              <div class="leads-item-hgsj">
                <img src="~@/assets/images/product/icon_深度调查.png" />
                <div class="leads-hgsj-1">
                  <div class="fontsize22">
                    搜邮寻客
                  </div>
                  <div class="fontsize18">搜索外企决策人邮箱</div>
                </div>
              </div>
            </router-link>
          </a-col>
          <a-col :xs="6" :xl="6">
            <a
              @click="showModal"
              data-source="p"
              onmouseover="linkDataSource(this)"
              a-type="register"
              target="_blank"
            >
              <div class="leads-item-hgsj">
                <img src="~@/assets/images/product/icon_智能询盘.png" />
                <div class="leads-hgsj-1">
                  <div class="fontsize22">
                    商机挖掘
                  </div>
                  <div class="fontsize18">孵化挖掘有效商机</div>
                </div>
              </div>
            </a>
          </a-col>
          <a-col :xs="6" :xl="6">
            <a
              @click="showModal"
              data-source="p"
              onmouseover="linkDataSource(this)"
              a-type="register"
              target="_blank"
            >
              <div class="leads-item-hgsj">
                <img src="~@/assets/images/product/icon_客户开发.png" />
                <div class="leads-hgsj-1">
                  <div class="fontsize22">
                    客户推荐
                  </div>
                  <div class="fontsize18">智能客户线索推荐</div>
                </div>
              </div>
            </a>
          </a-col>
          <a-col :xs="6" :xl="6">
            <a
              @click="showModal"
              data-source="p"
              onmouseover="linkDataSource(this)"
              a-type="register"
              target="_blank"
            >
              <div class="leads-item-hgsj">
                <img src="~@/assets/images/product/icon_简化交互流程.png" />
                <div class="leads-hgsj-1">
                  <div class="fontsize22">
                    客户动态
                  </div>
                  <div class="fontsize18">监控预警目标客户动态</div>
                </div>
              </div>
            </a>
          </a-col>
        </a-row>
      </div>
    </AbBlock>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import AbBlock from "@/components/AbBlock.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  components: {
    AbBlock,
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.ab-leads-data{
  padding-top:106px;
  padding-bottom:80px;
  .leads-item-industry{
    background: #FFFFFF;
    border-top: 1px solid #D6EAFF;
    margin-top:60px;
    .leads-item-hgsj{
      border-bottom:1px solid #D6EAFF;
      border-right:1px solid #D6EAFF;
      height:180px;
      display:flex;
    justify-content: center;
    align-items: center;
    .fontsize22{
      margin-top:5px;
    }
    .fontsize18{font-family: Alibaba-PuHuiTi-R;
      color:#666
    }
      img{
        width:90px;
        height:90px;
        margin-right:12px;
      }
    }
    .leads-item-list{
      background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
       height: 360px;
       color:#fff;
       font-family: AlibabaPuHuiTiM, Alibaba-PuHuiTi;
       padding:50px 60px 0px 60px;
       p.fontsize16{
        margin-bottom:6px;
        i{
          width: 8px;
          height: 8px;
          background: #FFFFFF;
          border-radius: 50%;
          display: inline-block;
          position: relative;
          top: -2px;
           margin-right: 4px;
        }
       }
       div.fontsize16{
        line-height: 22px;
        padding:15px 0px 40px 0px
       }
    }

  }

}
</style>
